import { Component } from "react";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { formatDateTime } from "@app/shared/formatDateTime";
import { NetNewProviderHistoryEntry } from "@app/projects/results/net-new-provider/netNewProviderHistory";
import { ProjectionProviderHistoryType } from "@app/projects/enumerators";
import { TimelineEvent } from "@app/shared/timeline/TimelineEvent";


interface NetNewProviderHistoryEntryProps {
  historyEntry: NetNewProviderHistoryEntry;
}

export default class NetNewProviderHistoryEntryDisplay extends Component<NetNewProviderHistoryEntryProps> {
  constructor(props: NetNewProviderHistoryEntryProps) {
    super(props);
  }

  public render() {
    const entry = this.props.historyEntry;
    const title = (this.props.historyEntry.projectionProviderHistoryType === ProjectionProviderHistoryType.Created || this.props.historyEntry.projectionProviderHistoryType === ProjectionProviderHistoryType.Cloned) ? "Created" : "Updated";
    const subtitile = this.props.historyEntry.projectionProviderHistoryType === ProjectionProviderHistoryType.Cloned ? "Copied from another project on " : "";

    return (
      <>
        <TimelineEvent
          key={`timelineEvent:${entry.historyEntryTime.valueOf()}`}
          icon={<QesIcon iconName={QesIcons.Calendar} isDecorative={true} width="24" />}
          title={`${title} by ${entry.userName} ${this.props.historyEntry.projectionProviderHistoryType === ProjectionProviderHistoryType.Cloned ? "" : "on"}`}
          subtitle={`${subtitile}${formatDateTime(entry.historyEntryTime)}`}
        >
          <dl className="container timeline-container">
            <div className="row">
              <dt className="col-xs-12 col-sm-12 col-md-3">
                <span className="demibold">Specialty Code:</span>
              </dt>
              <dd className="col-xs-12 col-sm-12 col-md-9">
                {entry.specialtyCode}
              </dd>
            </div>
            <div className="row">
              <dt className="col-xs-12 col-sm-12 col-md-3">
                <span className="demibold">Reason:</span>
              </dt>
              <dd className="col-xs-12 col-sm-12 col-md-9">
                {entry.reasonName}
              </dd>
            </div>
            <div className="row">
              <dt className="col-xs-12 col-sm-12 col-md-3">
                <span className="demibold">Comment:</span>
              </dt>
              <dd className="col-xs-12 col-sm-12 col-md-9">
                {entry.reasonDescription}
              </dd>
            </div>
            <div className="row">
              <dt className="col-xs-12 col-sm-12 col-md-3">
                <span className="demibold">Targeted:</span>
              </dt>
              <dd className="col-xs-12 col-sm-12 col-md-9">
                {entry.isTargeted ? <i className="fa fa-check" /> : <>&nbsp;</>}
              </dd>
            </div>
          </dl>
        </TimelineEvent>
      </>
    );
  }

}
